import { theme } from 'antd';
import SuperFetch from 'library/helpers/superFetch';
import fieldsValidator from 'library/helpers/validators/fieldsValidator';
import { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Form, Input, Modal } from 'zui/Antd';
import { ConditionalTooltipButton } from 'zui/Custom';

const { TextArea } = Input;

const BuySmartLockButton = ({ children, type }) => {
	const {
		token: { colorTextDescription }
	} = theme.useToken();
	// Hooks
	const [form] = Form.useForm();
	const person = useSelector((state) => state.Auth.selectedProfile);

	// Local States
	const [confirmLoading, setConfirmLoading] = useState(false);
	const [visible, setVisible] = useState(false);

	const handleSubmit = async () => {
		setConfirmLoading(true);
		const formData = form.getFieldsValue(true);
		const data = {
			personID: person.personID,
			orgID: person.orgID,
			inquiry: formData.inquiry
		};

		SuperFetch.post('/access/inquiryEmail', {
			data
		}).then((res) => {
			if (res.statusCode === 200) {
				Notification('success', 'Your inquiry has been sent successfully.');
				return true;
			} else {
				Notification('error', 'There is an Error! We are mending the problem, try again soon!.');
			}
		});

		handleCancel();
		setConfirmLoading(false);
	};

	const handleCancel = () => {
		setVisible(false);
		form.resetFields();
	};

	return (
		<Fragment>
			<ConditionalTooltipButton
				buttonText={`Buy Smart ${type ? type : ' Locks'}`}
				onClick={() => setVisible(true)}
			>
				{children}
			</ConditionalTooltipButton>

			<Modal
				title='Buy Smart Locks'
				open={visible}
				onCancel={handleCancel}
				destroyOnClose={true}
				footer={[
					<Button key='back' onClick={handleCancel}>
						Cancel
					</Button>,
					<Button key='submit' loading={confirmLoading} htmlType='submit' form={form} type='primary'>
						Send Inquiry
					</Button>
				]}
			>
				<Form form={form} id={form} onFinish={handleSubmit} layout='vertical'>
					<Form.Item
						name='inquiry'
						label='Enter your purchase inquiry below:'
						rules={[
							{ required: true, message: 'Please input your inquiry!', whitespace: false },
							[...fieldsValidator.Description]
						]}
					>
						<TextArea
							allowClear
							autoSize={{ minRows: 2, maxRows: 6 }}
							style={{ color: colorTextDescription }}
						/>
					</Form.Item>
				</Form>
			</Modal>
		</Fragment>
	);
};

export default BuySmartLockButton;
